import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface CandidateRetakeArgs {
  response_id: number | string;
}

export const useCandidateRetake = () => {
  const { openToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ response_id }: CandidateRetakeArgs) => {
      const res = await apiClient.post('/assessment/candidate-retake/', {
        response_id,
      });
      return res.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Retake Allowed',
        text: 'A new assessment link has been sent to the candidate.',
        type: 'success',
        timeOut: 5000,
      });
      queryClient.invalidateQueries({ queryKey: ['reportDetails'] });
      queryClient.invalidateQueries({ queryKey: ['reviewTalentsCandidates'] });
    },
    onError: (err: any) => {
      const serverMsg =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message;
      openToast({
        show: true,
        heading: 'Retake Failed',
        text: serverMsg || 'Failed to allow retake. Please try again.',
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};
